<div class="duration-inputs-wrapper" [class.from-trigger]="fromTrigger()">
  @if (durationType() === 'hrs' || durationType() === 'hrs/min') {
    <input
      #hoursInput
      type="text"
      inputmode="numeric"
      placeholder="hrs"
      class="duration-input"
      [class.from-trigger]="fromTrigger()"
      [style.background]="backgroundColor()"
      [value]="hours()"
      (input)="onInput($event, 'hours')"
      (blur)="onBlur('hours')"
      (keydown)="onKeydown($event, 'hours')"
    />
  }
  @if (durationType() === 'hrs/min' || durationType() === 'min' || durationType() === 'min/sec') {
    @if (durationType() === 'hrs/min') {
      <span class="duration-separator">:</span>
    }
    <input
      #minutesInput
      type="text"
      inputmode="numeric"
      placeholder="min"
      class="duration-input"
      [class.from-trigger]="fromTrigger()"
      [style.background]="backgroundColor()"
      [value]="minutes()"
      (input)="onInput($event, 'minutes')"
      (blur)="onBlur('minutes')"
      (keydown)="onKeydown($event, 'minutes')"
    />
  }
  @if (durationType() === 'min/sec') {
    <span class="duration-separator">:</span>
    <input
      #secondsInput
      type="text"
      inputmode="numeric"
      placeholder="sec"
      class="duration-input"
      [class.from-trigger]="fromTrigger()"
      [style.background]="backgroundColor()"
      [value]="seconds()"
      (input)="onInput($event, 'seconds')"
      (blur)="onBlur('seconds')"
      (keydown)="onKeydown($event, 'seconds')"
    />
  }
</div>
